import { Container } from 'styles/global'
import { Detail } from '../detail'
import { ProjectIntro } from '../projectintro'
import { useLanguage } from 'languages/language'

const Eriwen = () => {
  const { texts } = useLanguage()
  return (
    <Container>
      <ProjectIntro project={texts.eriwen} />
      <Detail
        dir="left"
        media={texts.eriwen.imgs[0]}
        text={texts.eriwen.texts[0]}
      />
      <Detail
        dir="right"
        media={texts.eriwen.imgs[1]}
        text={texts.eriwen.texts[1]}
      />
      <Detail
        dir="left"
        media={texts.eriwen.imgs[2]}
        text={texts.eriwen.texts[2]}
      />
    </Container>
  )
}
export default Eriwen
